<template>
  <div id="invitation">
    <van-row>
      <van-col span="24">
        <van-list
          v-model="show"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('other.there_is_no_more')"
          @load="onLoad"
          :offset="10"
        >
          <van-cell v-for="t in list" :key="t.id">
            <van-col span="24" class="invite_details_vue_type">
              <van-col span="19" class="invite_details_vue_name">
                <van-col span="24" class="invite_details_vue_name1">{{ t.name }}</van-col>
                <van-col span="24" class="invite_details_vue_name2">{{ t.addtime }}</van-col>
              </van-col>
              <van-col span="5" class="invite_details_vue_coin">+ {{ t.coin }}</van-col>
            </van-col>
          </van-cell>
        </van-list>
        <van-col span="24" v-if="is_show" class="no_val">
          <van-icon name="underway-o" /> &nbsp;&nbsp;&nbsp;{{ $t('other.no_record')}}
        </van-col>
      </van-col>
      <van-col span="24" class="iphonex_bottom"></van-col>
    </van-row>

  </div>
</template>
<script>
  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  export default {
    data() {
      return {
        list: [],
        show: false,
        finished: false,
        page: 1,
        page_size: 0,
        is_show: false
      }
    },
    created: function() {
      this.page = 1
      this.list = []
      this.convert()
      document.title = this.$t('title.invitation_earnings')
    },
    methods: {
      convert: function() {
        const token = this.$route.query.token
        const type = this.$route.query.type
        const consumers = this.$route.query.consumers
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=invite_vue&act=earnings", {
          params : {
            token: token,
            type: type,
            consumers: consumers,
            page: this.page
          }
        }).then(res =>{
          console.log(res.data)
          for (var j=0; j<res.data.data.list.length;j++ ){
            this.list.push(res.data.data.list[j])
          }
          this.page_size = res.data.data.page_size

          //如果列表数据条数>=总条数，不再触发滚动加载
          if (res.data.data.list.length < this.page_size) {

            if (this.page === 1 && res.data.data.list.length === 0) {
              this.is_show = true
            } else if(this.page !== 1) {
              this.finished = true
            }
            this.loading = false
          }
          if (res.data.status === 0) {
            Toast(res.data.error)
            return false
          }
          this.show = false
        })
      },
      onLoad() {
        this.page++
        this.convert()
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/invitation_earnings.vue